import { ptBR } from 'date-fns/locale';
const datePtBr = {
  name: 'pt-BR',
  locale: ptBR
};
export default datePtBr;